module.exports = __webpack_public_path__ + "img/wave.cac36f5c.svg";